module.exports = __webpack_public_path__ + "img/Lesson-en.62d297c6.png";